import { render, staticRenderFns } from "./SatellitesWidget.vue?vue&type=template&id=23148308&"
import script from "./SatellitesWidget.vue?vue&type=script&lang=js&"
export * from "./SatellitesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports